import { StorageService } from '@xq/infrastructure';

export class DeleteStorageFileUseCase {
  static async execute(path: string) {
    const storageService = StorageService.getInstance();

    return storageService.deleteFile(path);
  }
}
